import { animate, animateChild, query, sequence, stagger, style, transition, trigger } from "@angular/animations";


export const staggerList = trigger('staggerList', [
  transition(':enter', [
    query('@staggerItem', stagger(80, animateChild()), { optional: false }),
  ]),
  transition(':leave', [
    query('@staggerItem', stagger(-50, animateChild()), { optional: false }),
  ]),
]);

export const staggerItem = trigger('staggerItem', [
  transition(':enter', [
    style({ height: 0, opacity: 0 }),
    animate('400ms ease', style({ height: '*', opacity: 1 })),
    query('.label', animateChild(), { optional: false }),
  ]),
  transition(':leave', [
    query('.label', animateChild(), { optional: false }),
    animate('300ms ease', style({ height: 0, opacity: 0 })),
  ]),
]);


export const fadeChild = trigger('fadeChild', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('300ms ease-out', style({ opacity: 1 })),
  ]),
  transition(':leave', [
    animate('200ms ease-in', style({ opacity: 0 })),
  ]),
]);